import React from "react";
import RuntimeEstimator from "./RuntimeEstimator";

class RuntimeEstimatorContainer extends React.Component {
  render() {
    return (
      <div className="page setup-page" style={{ minWidth: 900 }}>
        <div className="settings-form">
          <RuntimeEstimator />
        </div>
      </div>
    );
  }
}

export default RuntimeEstimatorContainer;

